module.exports = __webpack_public_path__ + "img/one-line-light.04751dcd.svg";